import MarketingSeo from "@/components/landing/MarketingSeo";
import Hero from "@/components/landing/Hero";
import Benefits from "@/components/landing/Benefits";
import HowItWorks from "@/components/landing/HowItWorks";
import DeferredSection from "@/components/landing/DeferredSection";
import PublicSiteLayout from "@/components/landing/PublicSiteLayout";

export default function Landing() {
  return (
    <PublicSiteLayout>
      <MarketingSeo />
      <Hero />
      <Benefits />
      <HowItWorks />
      <DeferredSection loader={() => import("@/components/landing/DemoSection")} placeholderClassName="min-h-[720px]" />
      <DeferredSection loader={() => import("@/components/landing/FeatureDeepDive")} placeholderClassName="min-h-[1100px]" />
      <DeferredSection loader={() => import("@/components/landing/PaymentsSection")} placeholderClassName="min-h-[760px]" />
      <DeferredSection loader={() => import("@/components/landing/SchedulingSection")} placeholderClassName="min-h-[760px]" />
      <DeferredSection loader={() => import("@/components/landing/MobileComingSoon")} placeholderClassName="min-h-[560px]" />
      <DeferredSection loader={() => import("@/components/landing/Testimonials")} placeholderClassName="min-h-[560px]" />
      <DeferredSection loader={() => import("@/components/landing/FAQ")} placeholderClassName="min-h-[620px]" />
      <DeferredSection loader={() => import("@/components/landing/FinalCTA")} placeholderClassName="min-h-[360px]" />
    </PublicSiteLayout>
  );
}
